import { OktaLogo } from "components/ui/systemLogos/OktaLogo";
import { useOpenGlobalErrorModal } from "hooks/useGlobalError";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { openCenteredPopup } from "utils/ui/openCenteredPopup";

import { BaseLoginButton } from "../BaseLoginButton";

export const OktaLoginButton: FC = () => {
  const { t } = useTranslation();
  const openGlobalErrorModal = useOpenGlobalErrorModal();

  const login = useCallback(() => {
    const popupWindow = openCenteredPopup({
      title: t("pages.signIn.sso.okta.signInWith"),
      url: "/okta",
    });

    if (!popupWindow) {
      openGlobalErrorModal(new Error(t("errors.popup.open")));
    }
  }, [t, openGlobalErrorModal]);

  return <BaseLoginButton Logo={OktaLogo} onClick={login} text={t("pages.signIn.sso.okta.signInWith")} />;
};
